// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { requestRmaButtonsStyles } from "@awc/Overrides/Widgets/RequestRma/RequestRmaButtons";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

requestRmaButtonsStyles.sendButton = {
    variant: "tertiary",
    css: css`
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

requestRmaButtonsStyles.cancelButton = {
    variant: "secondary",
    css: css`
        width: auto;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

requestRmaButtonsStyles.buttonsContainer = {
    css: css`
        margin-top: 12px;
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        justify-content: end;
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};

requestRmaButtonsStyles.termOfServiceStyle = {
    css: css`
        font-style: italic;
        width: 100%;
        text-align: right;
        ${xScreen("lte", "md")} {
            text-align: left;
        }
    `,
};
